import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Componente que hace scroll automático hacia arriba cuando cambia la ruta
 * Se debe colocar dentro del BrowserRouter pero fuera de las Routes
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const elementId = hash.substring(1);
      const t = window.setTimeout(() => {
        const element = document.getElementById(elementId);
        if (element) {
          const headerHeight = 100;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

          window.scrollTo({
            top: Math.max(0, offsetPosition),
            left: 0,
            behavior: 'smooth'
          });
        }
      }, 100);

      return () => window.clearTimeout(t);
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
    return undefined;
  }, [pathname, hash]);

  return null; // Este componente no renderiza nada
};

export default ScrollToTop;
